import { useTranslation } from "react-i18next";
function WebglCheck() {
    const { t } = useTranslation();
    function isWebGLSupported() {
        try {
            const canvas = document.createElement("canvas");
            // Try to get a WebGL rendering context
            const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
            // Check if the context was successfully created
            return !!gl;
        } catch (error) {
            return false;
        }
    }

    const isSupported = isWebGLSupported();
    if (!isSupported) {
        alert(t("Webgl is not supported"));
        return;
    }
    return null;
}

export default WebglCheck;
